import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { ICreditMap } from '@leedpulse-monorepo/interfaces';
import { ECreditAdjustmentReason } from '@leedpulse-monorepo/enums';

interface ResetSubscriptionCreditsResponse {
  subscription_id: string;
  credits: ICreditMap;
  credits_reset_at: number | null;
  credits_period_end: number | null;
}

async function resetSubscriptionCredits(
  subscriptionId: string,
  reason: ECreditAdjustmentReason,
  comment: string | null,
  auth: Authentication
): Promise<ResetSubscriptionCreditsResponse> {
  try {
    const response = await HttpClient.post(
      `/backoffice/subscriptions/${subscriptionId}/credits/reset`,
      { reason, comment },
      auth.token
    );
    return response.data;
  } catch (e: any) {
    console.error('resetSubscriptionCredits error:', e);
    throw new ResetSubscriptionCreditsFailure(e.message);
  }
}

export class ResetSubscriptionCreditsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default resetSubscriptionCredits;
